module.exports = __webpack_public_path__ + "static/media/mobile-green-bg.3da9ccd4.svg";